import { Users, Sparkles, Lightbulb, Target, Leaf, ArrowRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const benefits = [{
  text: "Build community with like-minded individuals",
  icon: Users
}, {
  text: "Gain access to exclusive events + experiences",
  icon: Sparkles
}, {
  text: "Learn from industry leaders",
  icon: Lightbulb
}, {
  text: "Stay consistent and inspired in your wellness journey",
  icon: Target
}, {
  text: "Experience wellness beyond the treatment room",
  icon: Leaf
}];
export default function WhyJoinBenefits() {
  return <section id="why-join-benefits" className="py-20 md:py-32 bg-background text-foreground overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          
          {}
          <div className="lg:col-span-5 lg:sticky lg:top-32 space-y-8">
            <div className="space-y-6">
              <Badge variant="outline" className="rounded-full px-4 py-1.5 border-border text-foreground font-sans text-sm tracking-wide">
                Membership Benefits
              </Badge>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-default tracking-tight text-foreground leading-[1.1]">
                Why Join The Collective?
              </h2>
              <p className="text-lg md:text-xl text-muted-foreground font-sans leading-relaxed max-w-md">
                Elevate your wellness journey with exclusive access, expert guidance, and a community that supports your growth every step of the way.
              </p>
            </div>
            
            <div className="pt-4">
              <Button asChild size="lg" className="rounded-full px-8 h-14 text-base bg-green-accent hover:bg-green-accent/90 border-none">
                <Link to="/MembershipsPage">
                  Explore Memberships <ArrowRight className="ml-2 size-5" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="lg:col-span-7 space-y-4 md:space-y-6 mt-10 lg:mt-0">
            {benefits.map((benefit, i) => {
            const Icon = benefit.icon;
            return <div key={i} data-index={i} className="group flex items-center gap-6 p-6 sm:p-8 rounded-3xl border border-border bg-card hover:border-primary/20 hover:shadow-lg transition-all duration-500 ease-out">
                  <div className="shrink-0 w-16 h-16 rounded-2xl bg-secondary flex items-center justify-center group-hover:scale-110 group-hover:bg-primary group-hover:text-primary-foreground transition-all duration-500 ease-out">
                    <Icon className="size-7 text-primary group-hover:text-primary-foreground transition-colors duration-500" strokeWidth={1.5} />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl md:text-2xl font-semibold font-default text-card-foreground leading-snug">
                      {benefit.text}
                    </h3>
                  </div>
                </div>;
          })}
          </div>

        </div>
      </div>
    </section>;
}